// AntD Theme Configuration - Animap Brand Theme

export const theme = {
  token: {
    // Primary Colors - Animap Brand
    colorPrimary: '#9FB18C',           // Sage green (Pantone 7494 C)
    colorSuccess: '#9FB18C',           // Use primary green for success
    colorWarning: '#DAC38E',           // Gold/tan (Pantone 467)
    colorError: '#E57373',             // Soft red
    colorInfo: '#9FB18C',              // Use primary green

    // Background - Warm, natural tones
    colorBgBase: '#FFFFFF',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#F9FAF7',        // Very light sage tint
    colorBgLayout: '#F5F7F2',          // Light natural background

    // Border - Soft sage tones
    colorBorder: '#D4DBC9',            // Light sage border
    colorBorderSecondary: '#E5EBD9',   // Very light sage

    // Text
    colorText: '#2C3E2D',              // Dark green-gray
    colorTextSecondary: '#5A6B5C',     // Medium sage gray
    colorTextTertiary: '#8A9A8C',      // Light sage gray

    // Border Radius - Friendly, rounded
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    borderRadiusXS: 6,

    // Font
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 14,
    fontSizeHeading1: 38,
    fontSizeHeading2: 30,
    fontSizeHeading3: 24,
    fontSizeHeading4: 20,
    fontSizeHeading5: 16,

    // Spacing
    marginXS: 8,
    marginSM: 12,
    margin: 16,
    marginMD: 20,
    marginLG: 24,
    marginXL: 32,
    marginXXL: 48,

    // Shadows - Soft and natural
    boxShadow: '0 2px 8px rgba(159, 177, 140, 0.12)',
    boxShadowSecondary: '0 4px 16px rgba(159, 177, 140, 0.16)',

    // Line Height
    lineHeight: 1.6,
    lineHeightHeading1: 1.2,
    lineHeightHeading2: 1.3,
    lineHeightHeading3: 1.4,
  },

  components: {
    Button: {
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      fontWeight: 500,
      primaryShadow: '0 2px 8px rgba(159, 177, 140, 0.3)',
    },

    Card: {
      borderRadiusLG: 16,
      boxShadowTertiary: '0 2px 8px rgba(159, 177, 140, 0.1)',
      paddingLG: 24,
    },

    Input: {
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      paddingBlock: 8,
      paddingInline: 12,
    },

    Select: {
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
    },

    Menu: {
      itemBorderRadius: 12,
      itemMarginBlock: 4,
      itemMarginInline: 4,
    },

    Tag: {
      borderRadiusSM: 12,
      defaultBg: '#EFF3E8',            // Light sage background
      defaultColor: '#9FB18C',          // Primary green
    },

    Table: {
      borderRadius: 12,
      headerBg: '#F5F7F2',
      headerColor: '#2C3E2D',
      rowHoverBg: '#EFF3E8',
    },

    Modal: {
      borderRadiusLG: 16,
      contentBg: '#FFFFFF',
      headerBg: '#F5F7F2',
    },

    Message: {
      contentBg: '#FFFFFF',
      borderRadiusLG: 12,
    },

    Notification: {
      borderRadiusLG: 16,
    },
  },
};
